import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  size: PropTypes.string,
};

const OperaIcon = ({ size = '32', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Chromium"
    viewBox="0 0 512 512"
    width={size}
    {...props}
  >
    <circle cx="256" cy="256" r="256" fill="#afcbfa" />
    <path d="M34.3 128A256 256 0 0 0 256 512l111-192" fill="#669df6" />
    <path d="M34.3 128a256 256 0 0 1 443.4 0H256L145 320" fill="#1967d2" />
    <circle
      cx="256"
      cy="256"
      r="114.7"
      fill="#1a73e8"
      stroke="#fff"
      strokeWidth="26.7"
    />
  </svg>
);

OperaIcon.propTypes = propTypes;

export default OperaIcon;
